import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

/**
 * CSRF double-submit cookie helper. See backend
 * src/middleware/csrf/csrf.js for the contract.
 */
@Injectable({ providedIn: 'root' })
export class CsrfService {
  private static readonly COOKIE_NAME = 'csrf-token';

  constructor(private http: HttpClient) {}

  private endpoint(): string {
    // Admin baseUrl is already at /api/v1/, so just append 'csrf'.
    // Strip any trailing vendor segment defensively in case the value
    // ever changes.
    return environment.baseUrl.replace(/\/\d+\/?$/, '/') + 'csrf';
  }

  bootstrap(): Observable<unknown> {
    return this.http
      .get(this.endpoint(), { withCredentials: true })
      .pipe(catchError(() => of(null)));
  }

  getToken(): string | null {
    if (typeof document === 'undefined' || !document.cookie) return null;
    for (const part of document.cookie.split(';')) {
      const [rawName, ...rawValue] = part.trim().split('=');
      if (rawName === CsrfService.COOKIE_NAME) {
        return decodeURIComponent(rawValue.join('='));
      }
    }
    return null;
  }
}
